module.exports = __webpack_public_path__ + "img/user.f37d771d.jpg";